import React from 'react';
import './css/no-videos-container.css';
import UploadWrapper from "./UploadWrapper";

function NoVideos() {
    return (
        <div className="no-videos">
            <div className="no-videos-container">
                <h1>Welcome!<span className={'mobile'}/> Let's make a funny video!</h1>
                <div className={'btn-with-arrow'}>
                    <UploadWrapper>
                        <button className="btn third">Upload my first video
                        </button>
                    </UploadWrapper>
                    <img src={'./images/arrow.png'} className={'arrow desktop'} alt={'Arrow'}/>
                </div>
            </div>
        </div>
    );
}


export default NoVideos;
